import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Product } from 'types/product';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface ProductItemProps {
  option: Product;
  selected: Product | null;
  handleSelect(product: Product): void;
}

const ProductItem: React.FC<ProductItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default ProductItem;
